module.exports = __webpack_public_path__ + "static/pannonia-cover-ee1230bf41090757c02819a6b3ad792d.jpg";